export const drawMarker = (
  e,
  add,
  addSelectType,
  setSiteSetupDialogBox,
  setOurData,
  showTeeMarkers,
  setOpenModel,
  showPointsOfInterest,
  siteSettingsTypes
) => {
  if (!add) {
    return;
  }

  const lat = e.detail.latLng.lat;
  const lng = e.detail.latLng.lng;

  if (add) {
    setSiteSetupDialogBox({ lat: lat, lng: lng });

    if (addSelectType === siteSettingsTypes.teeMarkers) {
      setOurData((prev) => ({
        ...prev,
        tee: [...prev.tee, { lat: lat, lng: lng }],
      }));
      showTeeMarkers.set(true);
      setOpenModel(true);
    } else if (addSelectType === siteSettingsTypes.pointOfInterest) {
      setOurData((prev) => ({
        ...prev,
        poi: [...prev.poi, { lat: lat, lng: lng }],
      }));
      showPointsOfInterest.set(true);
      setOpenModel(true);
    } else if (addSelectType === siteSettingsTypes.centerOfGreen) {
      setOurData((prev) => ({
        ...prev,
        cog: [...prev.cog, { lat: lat, lng: lng }],
      }));
      setOpenModel(true);
    }
  }
};